import { Box, Typography } from "@mui/material";
import { ArrowForward } from "@mui/icons-material";
import { formatMXN } from "./factoraje.helpers";

interface Props {
  /** Lo que se pidió en el cotizador. */
  solicitado: number;
  /** Lo que suman las empresas registradas. */
  nuevo: number;
}

/** `.fxu-conf` del diseño de Flux: monto de la cotización → monto de la nueva solicitud. */
export const BoxComparacionLinea = ({ solicitado, nuevo }: Props) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 2,
      p: "12px 16px",
      borderRadius: "10px",
      bgcolor: "#F2F5F9",
      textAlign: "left",
    }}
  >
    <Box>
      <Typography sx={{ fontSize: 11, color: "text.secondary" }}>Cotización</Typography>
      <Typography sx={{ fontSize: 15, fontWeight: 700, color: "text.primary" }}>{formatMXN(solicitado)}</Typography>
    </Box>
    <ArrowForward sx={{ fontSize: 14, color: "text.secondary" }} />
    <Box sx={{ textAlign: "right" }}>
      <Typography sx={{ fontSize: 11, color: "text.secondary" }}>Nueva solicitud</Typography>
      <Typography sx={{ fontSize: 15, fontWeight: 700, color: "primary.accent" }}>{formatMXN(nuevo)}</Typography>
    </Box>
  </Box>
);
